export const enChangeEmailTranslations = {
    CHANGE_EMAIL__TITLE: 'Email change',
    CHANGE_EMAIL__WE_ARE_CHANGING: 'We are changing you email...',
    CHANGE_EMAIL__INCORRECT_LINK: 'It seems, your link is incorrect',
    CHANGE_EMAIL__ERROR_WHILE_CHANGING: 'An error occurred while trying to change your email',
    CHANGE_EMAIL__SUCCESS: 'Your email has been changed successfully',
};
